export default users => users.map(user => user.userName);
